import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Button from 'components/buttons/Button';
// import PlusCircleOutlineIcon from 'mdi-react/PlusCircleOutlineIcon';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withNamespaces } from 'react-i18next';
import { apiGoogleOauthUrl } from 'constants/apiRouting';
import { CREATE_GOOGLE_OAUTH_CONFIG } from 'constants/analytics';
import { ReactComponent as GmailLogo } from 'icons/gmail.svg';
import { redirectApp } from 'utils/misc';
import { analyticsTrack } from 'utils/analytics';
import GoogleAppVerificationDialog from './GoogleAppVerificationDialog';

class EmailGoogleOauthCreate extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    accountId: PropTypes.string.isRequired,
    btnLabel: PropTypes.string,
    startIcon: PropTypes.element,
    btnProps: PropTypes.shape({}),
  };

  static defaultProps = {
    className: '',
    btnLabel: 'Gmail',
    startIcon: <GmailLogo />,
    btnProps: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      isDialogOpen: false,
    };
    this.toggleDialog = this.toggleDialog.bind(this);
  }

  toggleDialog = () => {
    this.setState({
      isDialogOpen: !this.state.isDialogOpen,
    });
  }

  handleClick = () => {
    this.toggleDialog();
  }

  handleSuccess = () => {
    analyticsTrack(CREATE_GOOGLE_OAUTH_CONFIG, { account: this.props.accountId }, true);
    redirectApp(apiGoogleOauthUrl(), { account_id: this.props.accountId });
  }

  render() {
    const {
      className,
      btnLabel,
      startIcon,
      btnProps,
    } = this.props;
    const { isDialogOpen } = this.state;
    return (
      <div className={className}>
        <Button
          className="mb-2 pl-2"
          color="secondary"
          startIcon={startIcon}
          onClick={this.handleClick}
          variant="outlined"
          {...btnProps}
        >
          {btnLabel}
        </Button>
        <GoogleAppVerificationDialog
          isOpen={isDialogOpen}
          handleClose={this.toggleDialog}
          handleSuccess={this.handleSuccess}
        />
      </div>
    );
  }
}

export default compose(
  connect(
    state => ({
      config: state.config,
    }),
    {},
  ),
  withNamespaces('common'),
)(EmailGoogleOauthCreate);
